import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import ForgotPasswordLayout from './Layout';

const NewPasswordWithEmail = loadable(() => pMinDelay(import('./NewPasswordWithEmail'), 300), {
  fallback: <Loading />
});

const AsyncNewPasswordWithEmail = props => {
  const isDesktop = props.userAgent.device?.type === 'desktop';
  const pageConfig = {
    headerType: isDesktop ? 'login-only' : 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      }
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <ForgotPasswordLayout isDesktop={ isDesktop }>
        <NewPasswordWithEmail { ...props }/>
      </ForgotPasswordLayout>
    </ApplicationLayout>
  );
};

AsyncNewPasswordWithEmail.propTypes = {
  userAgent: PropTypes.object
};

export default AsyncNewPasswordWithEmail;
